/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left-thick': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 10v4h-9l3.5 3.5-2.42 2.42L4.16 12l7.92-7.92L14.5 6.5 11 10h9z"/>'
  }
})
